type TError = {
  error: string;
  message: string;
  path: string;
  status: number;
  timestamp: number;
};

type TFetchParams = Parameters<typeof fetch>;

export async function fetcher<TData = object | string>(
  url: TFetchParams[0],
  fetchOptions?: TFetchParams[1],
) {
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...(fetchOptions?.headers || {}), // Merge custom headers with the default ones.
      },
      body: fetchOptions?.body ? JSON.stringify(fetchOptions.body) : undefined,
      ...fetchOptions, // Include any other fetch options passed in.
    });

    if (!response.ok) {
      // Handle non-OK responses separately.
      const errorData: TError = await response.json();
      throw new Error(
        `${errorData.error} ${errorData.status}: ${errorData.message}`,
      );
    }
    const text = await response.text();
    const isEmpty = text.trim().length === 0;

    if (isEmpty) {
      return response.status;
    }

    const data: TData = JSON.parse(text);
    return data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Error fetching data: ${error.message}`);
    } else {
      throw new Error(`Error fetching data: Unknown error`);
    }
  }
}
